
import './App.css';
import Main from './components/Main';
import Navbar from './components/Navbar';



function App() {
  return (
    <div className="App">
      <Navbar />
    </div>
  );
}

export default App;
